// extracted by mini-css-extract-plugin
module.exports = {"imgDiv":"AssignmentType_imgDiv__31i4g"};